import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { MemberInsurerServiceService } from './member-insurer-service.service';
import { Subject } from 'rxjs';
import { AdminUser, NewAgent } from '../models/modeladmins';


@Injectable({
  providedIn: 'root'
})

export class AdminsRestService {
  protected ngUnsubscribe: Subject<void> = new Subject<void>();
  private baseUrl = `${environment.apiUrl}/lps`;

  constructor(private http: HttpClient, private memberService: MemberInsurerServiceService) { }

  getAdminsByRole() {
    const role = this.memberService.getUserAccess();
    return this.http.get<AdminUser[]>(`${this.baseUrl}/api/admin?role=${role}`);
  }

  getAgentsByOrgandRole() {
    const role = this.memberService.getLoginUserRole();
    const orgid = this.memberService.getOrg();
    return this.http.get<NewAgent[]>(`${this.baseUrl}/api/admin/users?orgId=${orgid}&role=${role}`);
  }

  getStatusCounts(agentId?: string) {
    const role = this.memberService.getLoginUserRole().toLocaleLowerCase();
    let url = `${this.baseUrl}/api/admin/${role}/status-summary`;

    if (agentId) {
      url += `?agentIds=${agentId}`;
    }

    return this.http.get<any>(url);
  }


  getProgressonAgentandCycle(agentId?: string, timeRange?: string) {
    const role = this.memberService.getLoginUserRole();
    const adminId = this.memberService.getLoginUserId(); // fallback
    const finalAgentId = agentId || adminId; // use agentId if exists, else adminId

    const url = `${this.baseUrl}/api/admin/${role.toLowerCase()}/consolidated?adminId=${finalAgentId}&timeRange=${timeRange || ''}&role=${role}`;

    return this.http.get<any>(url);
  }

  getRecentActivities(agentId?: string) {
    const role = this.memberService.getLoginUserRole();
    let url = `${this.baseUrl}/api/agent-activities?dashboard=${role}`;
    if (agentId) {
      url += `&adminId=${agentId}`;
    }
    return this.http.get<any>(url);
  }


}